import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

interface AppError {
  message: string
}

interface sponsorhipData {
  data: any
  overviewData: any
  loading: boolean
  error: AppError | null
}

const SponsorshipRepository: any = RepositoryFactory.get('SponsorshipRepository')

export const useSponsorshipStore = defineStore('sponsorship', {
  state: () =>
    <sponsorhipData>{
      data: StorageHelper.getItem('sponsorshipData', []),
      overviewData: StorageHelper.getItem('overviewData', []),
      error: null,
      loading: true
    },
  getters: {
    getSponsorshipData: (state) => state.data,
    getSponsorshipOverviewData: (state) => state.overviewData
  },
  actions: {
    async fetchSponsorshipData(slug: string, template: string) {
      this.loading = true
      try {
        this.data = (
          await SponsorshipRepository.getPageTypeOneBySlug({}, slug, template)
        ).data.fields
        StorageHelper.setItem('sponsorshipData', this.data)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching sponsorship data'
        }
        throw error
      } finally {
        this.loading = false
      }
    },
    async fetchSponsorshipOverview() {
      this.loading = true
      try {
        this.overviewData = (await SponsorshipRepository.getSponsorshipOverview()).data.fields
        StorageHelper.setItem('overviewData', this.overviewData)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'Problem with fetching sponsorship overview data'
        }
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
